export default __webpack_public_path__ + "static/media/icon_Paypal.6043e7c0.svg";